import * as React from 'react'

import Svg from './..'

const ExclamationTriangle = props => {
  return (
    <Svg viewBox='0 0 36 32' fill='none' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.813 24.75c0-1.531-1.282-2.813-2.813-2.813-1.531 0-2.813 1.282-2.813 2.813 0 1.531 1.282 2.813 2.813 2.813 1.531 0 2.813-1.282 2.813-2.813zm-1.125-4.5L20.25 9h-4.5l.563 11.25h3.375zM20.813 0L36 27l-3.375 4.5H3.375L0 27 15.188 0h5.624z'
        fill='#BBB2B7'
      />
    </Svg>
  )
}

export default ExclamationTriangle
